import { useEffect } from "react";

/**
 * Renderowane WEWNĄTRZ <Suspense>, więc useEffect odpali się dopiero po rozwiązaniu
 * lazy chunku pierwszej trasy. Wtedy chowamy bootloader z index.html, dzięki czemu
 * użytkownik nie widzi dwóch spinnerów (bootloader + RouteFallback) pod rząd.
 */
type WinWithBoot = Window & {
  __lovHideBoot?: () => void;
  __lovBootHidden?: boolean;
};

export const BootCleanup = () => {
  useEffect(() => {
    const w = window as unknown as WinWithBoot;
    try {
      w.__lovHideBoot?.();
      w.__lovBootHidden = true;
    } catch {
      /* noop */
    }
  }, []);
  return null;
};
